import { useTranslation } from "react-i18next";

export const useI18n = () => {
  const { t: originalT, i18n } = useTranslation();

  const t = (key: string, fallback?: string): string => {
    if (typeof key !== 'string') {
      return fallback || '';
    }
    const translation = originalT(key);
    if (translation !== key) {
      return translation;
    }
    if (fallback) {
      return fallback;
    }
    const keyParts = key.split('.');
    return keyParts[keyParts.length - 1];
  };

  return {
    t,
    i18n,
  };
};

export default useI18n;
